import { memo as Memo } from 'react'

//* HOC's
import { withUIContext } from 'context'

//* Components
import Container from 'components/common/Container'
import CustomLink from 'components/common/CustomLink'
import Text from 'components/common/Text'
import Image from 'components/common/Image'
import Button from 'components/common/Button'

//* Styles
import RelatedPagesStyle from './style'

const RelatedPages = Memo(({ relatedPages, winWidth }) => {
    return (
        relatedPages && (
            <RelatedPagesStyle>
                <Container>
                    <Text tag={'h3'} text={'youMightAlsoBeInterestedIn'} className='h3 font-ping-bolder related-pages-title' />
                </Container>

                <Container row section>
                    {relatedPages.map((i, k) => (
                        <div key={k} className='col-6 col-t-12 col-m-12 related-item-cont'>
                            <CustomLink url={`/${i.slug}`} className='related-item'>
                                {winWidth >= 768 && <Image objectFit='cover' src={i.featured_image?.url} alt={i.featured_image?.alt} />}

                                <div className='related-item-info primaryColor3-bg'>
                                    <Text text={i.name} tag='h2' className={`font-ping-bolder related-item-info-title h6`} />
                                    <Text
                                        text={i.featured_description}
                                        tag='h3'
                                        className={`font-helvetica related-item-info-description secondaryColor2 p pS`}
                                    />
                                    <Button type='lottie' text='learnMore' />
                                </div>
                            </CustomLink>
                        </div>
                    ))}
                </Container>
            </RelatedPagesStyle>
        )
    )
})

export default withUIContext(RelatedPages, ['winWidth'])
